module.exports = __webpack_public_path__ + "stylesheets/comments_f37e505699d8374de2090bc7fd7334e4.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/comments.less
// module id = +goU
// module chunks = 118